/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { TourStopsDaoService } from '../tour-stop-dao.service';
import {
  DbPersistenceService,
  Query
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { AppConfig } from 'src/app/app.config';
import { TourStop } from 'src/app/_model/tour-stop';
import { TourStopDbTableDefinition } from './tour-stop-db-table-definition';

@Injectable()
export class TourStopsDbDaoService implements TourStopsDaoService {

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private tourStopTableDefinition: TourStopDbTableDefinition,
  ) { }

  public async saveTourStops(tourStops: TourStop[]): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();

      var tourStopsQueries: Query[] = [];
      for (const tourStop of tourStops) {
        let tourStopQuery: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
             this.tourStopTableDefinition.tableName +
            '(id, label, databag, tourid, tourlabel)' + // 5
            ' VALUES (?,?,?,?,?)',
          parameters: [
            Number(tourStop.isLocal() ? tourStop.id.secondaryId : tourStop.id.imsId),
            tourStop.label,
            tourStop.databag ? JSON.stringify(tourStop.databag) : undefined,
            tourStop.tour
              ? Number(tourStop.tour.getImsId())
              : undefined,
            tourStop.tour ? tourStop.tour.label : undefined,
          ]
        };
        tourStopsQueries.push(tourStopQuery);
      }
      await this.dbPersistenceService.executeBatch(db, tourStopsQueries);
    } catch (error) {
      this.logger.log(
        'Error saving tour stops to db',
        error,
        '-',
        error.message
      );
    }
  }

  public async getTourStops(): Promise<TourStop[]> {
    let db = await this.dbPersistenceService.getImsDb();
    let tourStops: TourStop[] = [];

    try {
      // Get Synced TourStops
      let data = await this.dbPersistenceService.executeQuery(db, {
        statement: 'SELECT * FROM ' + this.tourStopTableDefinition.tableName + ';',
        parameters: null
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        tourStops.push(
          TourStop.fromDto({
            id: row['id'],
            secondaryid: undefined,
            label: row['label'],
            tour: {
              id: row['tourid'],
              label: row['tourlabel']
            }
          }, row['databag'] ? JSON.parse(row['databag']): undefined)
        );
      }
    } catch (error) {
      this.logger.log('Error reading tour stops from db', error);
    }

    return tourStops;
  }

  public async reset() {
    // do nothing
  }

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(this.constructor.name, "truncate table", this.tourStopTableDefinition.tableName)
    await this.dbPersistenceService.truncateTable(db, this.tourStopTableDefinition.tableName);
  }

}
